import MuiPopover from '@material-ui/core/Popover';
import { makeStyles, mergeClasses } from '@material-ui/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const checkMargin = ({ anchorOrigin, transformOrigin }) => {
  if (anchorOrigin.vertical === 'top') {
    if (transformOrigin.horizontal === 'left') {
      return '-8px';
    }
    return '0px 8px';
  }
  return '-8px 8px';
};

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: theme.colors.transparent,
    margin: checkMargin,
  },
  popover: {
    borderRadius: theme.borderRadius.small,
    boxShadow: theme.shadow.componentDark,
    margin: 8,
    backgroundColor: theme.colors.white,
  },
}));

function Popover(props) {
  const { children, anchorOrigin, transformOrigin, classes, ...otherProps } = props;
  const { popover, ...otherClasses } = classes;
  const styles = useStyles({ anchorOrigin, transformOrigin });

  return (
    <MuiPopover
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
        ...anchorOrigin,
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        ...transformOrigin,
      }}
      classes={mergeClasses({ baseClasses: { paper: styles.paper }, newClasses: otherClasses })}
      {...otherProps}
    >
      <div className={classnames(styles.popover, popover)}>{children}</div>
    </MuiPopover>
  );
}

Popover.propTypes = {
  children: PropTypes.node.isRequired,
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'center', 'right', PropTypes.number]),
    vertical: PropTypes.oneOf(['top', 'center', 'bottom', PropTypes.number]),
  }),
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'center', 'right', PropTypes.number]),
    vertical: PropTypes.oneOf(['top', 'center', 'bottom', PropTypes.number]),
  }),
  classes: PropTypes.object,
};

Popover.defaultProps = {
  anchorOrigin: { vertical: 'bottom' },
  transformOrigin: { horizontal: 'right' },
  classes: {},
};

export default Popover;
